//
export default [
    {
        field: 'selectedTags',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Seleccione Tags (opcional)',
            multiple: true,
        },
        options: {
            data: [],
            text: 'tag',
            value: 'id',
        },
        value: '',
    },
    {
        field: 'selectedFamily',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Seleccione Familia (opcional)',
        },
        options: {
            data: [],
            text: 'family',
            value: 'id',
        },
        value: '',
    },
    {
        field: 'selectedSubfamily',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Seleccione Subfamilia (opcional)',
        },
        options: {
            data: [],
            text: 'subfamily',
            value: 'id',
        },
        value: '',
    },
]
